import React from 'react';
import { X } from 'lucide-react';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[var(--modal-overlay-background)] bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[var(--modal-background)] rounded-[20px] md:p-8 p-6 w-full max-w-sm mx-4 shadow-xl animate-scale-in">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-[var(--color-text)]">Confirm Logout</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={isLoading}
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-[var(--color-sub-title-text)] text-base font-normal">
          Are you sure you want to log out?
          You’ll need to sign in again to access your dashboard.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 justify-end text-sm font-semibold">
          <button
            onClick={onClose}
            className="px-5 py-2.5 border border-[var(--gradient-page-bottom-color)] text-[var(--color-terms-link)] hover:bg-[var(--button-hover)] rounded-md transition-colors"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2.5 bg-red-600 text-white hover:bg-red-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading ? 'Logging out...' : 'Logout'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;
